import React from 'react'
import {Route} from 'react-router-dom'

import TariffsPage from './pages/tariffs-page/TariffsPage'

const App: React.FC = () => {
  return <Route component={TariffsPage} path="/:country?/:zone?/:category?" />
}

export default App
